import { Link } from 'react-router-dom';
import type { FC } from 'react';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  categoryName: string;
  rating: number;
  tags?: string[];
  status?: string;
  latestChapter?: string;
  size?: 'sm' | 'md' | 'lg';
}

const ComicCard: FC<ComicCardProps> = ({
  id,
  title,
  author,
  cover,
  category,
  categoryName,
  rating,
  tags = [],
  status,
  latestChapter,
  size = 'md',
}) => {
  const imgHeight = size === 'sm' ? 'h-52' : size === 'lg' ? 'h-72' : 'h-60';

  return (
    <Link
      to={`/comic/${id}`}
      className="group block"
      data-product-shop
    >
      <div className={`relative ${imgHeight} rounded-lg overflow-hidden bg-background-100`}>
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        {status && (
          <span className={`absolute top-2 left-2 px-2 py-0.5 text-xs font-medium rounded ${
            status === '连载中'
              ? 'bg-accent-500 text-background-50'
              : 'bg-foreground-600 text-background-50'
          }`}>
            {status}
          </span>
        )}
        <div className="absolute top-2 right-2 flex items-center gap-1 px-1.5 py-0.5 bg-black/50 backdrop-blur-sm rounded text-xs text-background-50 font-medium">
          <i className="ri-star-fill text-accent-500 text-[10px]"></i>
          <span>{rating}</span>
        </div>
        {latestChapter && (
          <div className="absolute bottom-2 left-2 right-2 px-2 py-1 bg-black/60 backdrop-blur-sm rounded text-xs text-background-50 text-center truncate opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            {latestChapter}
          </div>
        )}
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
          {title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <Link
            to={`/category/${category}`}
            onClick={(e) => e.stopPropagation()}
            className="text-xs text-accent-600 hover:text-accent-700 whitespace-nowrap"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-400 truncate">{author}</span>
        </div>
        {tags.length > 0 && (
          <div className="flex items-center gap-1.5 mt-2 flex-wrap">
            {tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 text-[10px] rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
};

export default ComicCard;